import axiosInst from '../../libs/axios/axios'
import moment from 'moment-timezone'
import i18n from '../../i18n/i18n'

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  notifications: [],
  count: 0,
  cursor: null
}
const getters = {
  notificationList (state) {
    return state.notifications
  },
  notificationCount (state) {
    return state.count
  },
  notificationCursor (state) {
    return state.cursor
  }
}
const mutations = {
  notifications (state, info) {
    state.notifications = []
    info.results.map((value) => {
      state.notifications.push({
        id: value.id,
        title: i18n.t('notifications.NotificationType.Alarm'),
        msg: value.platform_message,
        icon: 'BellIcon',
        time: moment(value.created_at).format('DD-MM-YYYY HH:mm'),
        category: 'danger',
        link: value.link,
        is_read: value.is_read
      })
    })
  },
  notificationsUpdate (state, info) {
    info.results.map((value) => {
      state.notifications.push({
        id: value.id,
        title: i18n.t('notifications.NotificationType.Alarm'),
        msg: value.platform_message,
        icon: 'BellIcon',
        time: moment(value.created_at).format('DD-MM-YYYY HH:mm'),
        category: 'danger',
        link: value.link,
        is_read: value.is_read
      })
    })
  },
  cursor (state, info) {
    state.cursor = info
  },
  count (state, info) {
    state.count = info
  }
}


const actions = {
  getNotifications (store) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/notification/`).then(response => {
        store.commit('notifications', response.data)
        store.commit('cursor', response.data.next)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNotificationsCount (store) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/notification/count/`).then(response => {
        store.commit('count', response.data.count)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getNotificationsLazyLoadData (store, api) {
    return new Promise((resolve, reject) => {
      axiosInst.get(api).then(response => {
        store.commit('notificationsUpdate', response.data)
        store.commit('cursor', response.data.next)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  isReadNotification (store, id) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/notification/${  id  }/`, { }).then(response => {
        store.dispatch('getNotifications').catch(() => {})
        store.dispatch('getNotificationsCount').catch(() => {})
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
